import axios from 'axios';
import API_URL from './baseURL';


export const getRequests = async () => {
  const res = await axios.get(`${API_URL}/requests`);
  return res.data;
};

// Target status -> the route segment the backend actually exposes. These are
// NOT the same word in every case: 'in-progress' is served by /start and
// 'completed' by /complete (see backend/routes/maintenanceRequestRoutes.js).
// Both used to be sent as the status name and 404'd.
const STATUS_ENDPOINT = {
  accepted: 'accept',
  rejected: 'reject',
  declined: 'reject',
  rescheduled: 'reschedule',
  confirmed: 'confirm',
  'in-progress': 'start',
  completed: 'complete',
  cancelled: 'cancel',
};

export const updateRequestStatus = async (id, status, note, token) => {
  const segment = STATUS_ENDPOINT[status];
  const endpoint = segment
    ? `${API_URL}/requests/${id}/${segment}`
    : `${API_URL}/requests/${id}`;

  const res = await axios.patch(
    endpoint,
    { note },
    {
      headers: { Authorization: `Bearer ${token}` }
    }
  );
  return res.data;
};

const authHeaders = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

// Workshop books the slot and confirms it in one step. Does not wait on the
// client — see scheduleRequest in the backend controller for why.
export const scheduleRequest = async (id, date, note, token) => {
  const res = await axios.patch(
    `${API_URL}/requests/${id}/schedule`, { date, note }, authHeaders(token)
  );
  return res.data;
};

export const startRequest = async (id, token) => {
  const res = await axios.patch(`${API_URL}/requests/${id}/start`, {}, authHeaders(token));
  return res.data;
};

export const completeRequest = async (id, token) => {
  const res = await axios.patch(`${API_URL}/requests/${id}/complete`, {}, authHeaders(token));
  return res.data;
};

export const getWorkshopRequests = async (workshopId, token) => {
  const res = await axios.get(`${API_URL}/requests/workshop/${workshopId}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
};

export const getMyRequests = async (token) => {
  const res = await axios.get(`${API_URL}/requests/mine`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
};
